
export const UPDATE_OFFER_REQUEST = "UPDATE_OFFER_REQUEST";
export const UPDATE_OFFER_SUCCESS = "UPDATE_OFFER_SUCCESS";
export const UPDATE_OFFER_FAILURE = "UPDATE_OFFER_FAILURE";
